// tslint:disable:max-line-length
import * as React from 'react';

export const review = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
    <path fillRule="nonzero" d="M1.027 0C.5 0 .057.4 0 .925l.006 7.09C-.06 8.627.418 9 1.033 9h.96v3L5.04 9h5.933c.526 0 .97-.23 1.027-.755l-.006-7.175C12.06.457 11.584 0 10.967 0h-9.94zm2.96 4c0 .552-.445 1-.996 1a.996.996 0 0 1-.993-1 .999.999 0 0 1 1.995 0h-.006zM6.98 4a1 1 0 0 1-.998 1 1 1 0 0 1 0-2 1 1 0 0 1 .997 1h.001zm2.99 0a1 1 0 0 1-.997 1 1 1 0 0 1 0-2 1 1 0 0 1 .997 1z"/>
  </svg>
);

// tslint:enable:max-line-length
